module.exports = [{"value":"ประกันสังคม","text":"ประกันสังคม"},{"value":"บริษัทจัดหา","text":"บริษัทจัดหา"},{"value":"หมอพร้อม","text":"หมอพร้อม"},{"value":"ไทยร่วมใจ","text":"ไทยร่วมใจ"},{"value":"โครงการจังหวัด","text":"โครงการจังหวัด"},{"value":"โครงการอำเภอ","text":"โครงการอำเภอ"},{"value":"ซื้อด้วยตนเอง","text":"ซื้อด้วยตนเอง"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/vaccine/categoryName.json
// module id = 8Lpi
// module chunks = 2